import { render, staticRenderFns } from "./ModalDeclaracionDoctrinal.vue?vue&type=template&id=039c8154&"
import script from "./ModalDeclaracionDoctrinal.vue?vue&type=script&lang=js&"
export * from "./ModalDeclaracionDoctrinal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports